import React from 'react';
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import { AlertColor } from "@mui/material/Alert/Alert";

interface SnackbarAlertMessageProps {
    open: boolean;
    severity: AlertColor;
    message: string;
    onClose: () => void;
}

const SnackbarAlertMessage: React.FC<SnackbarAlertMessageProps> = ({ open, severity, message, onClose }) => (
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={open} autoHideDuration={6000} onClose={onClose}>
        <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
            {message}
        </Alert>
    </Snackbar>
);

export default SnackbarAlertMessage;
